import React, { useState, useEffect  } from 'react';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import '../styles/AreaObstacleAvoidanceSensor.css';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import sensorMain from '../assets/area_obstacle_avoidance_sensor_main.png';
import LidarSensorIMG from '../assets/Lidar Sensor IMG.jpg';
// import lidar1 from '../assets/lidar1.jpg';
// import lidar2 from '../assets/lidar2.jpg';
// import lidar3 from '../assets/lidar3.jpg';
import curtain1 from '../assets/safety_curtain_1.jpg';
import curtain2 from '../assets/safety_curtain_2.jpg';
import curtain3 from '../assets/safety_curtain_3.jpg';
import curtain4 from '../assets/safety_curtain_4.jpg';
import curtain5 from '../assets/safety_curtain_5.jpg';
import curtain6 from '../assets/safety_curtain_6.jpg';
import curtain7 from '../assets/safety_curtain_7.jpg';
import curtain8 from '../assets/safety_curtain_8.jpg';
import curtain9 from '../assets/safety_curtain_9.png';

import lock1 from '../assets/safety_lock_1.jpg';
import lock2 from '../assets/safety_lock_2.jpg';
import lock3 from '../assets/safety_lock_3.jpg';

import area_obstacle_avoidance_sensor_Fn from '../assets/area-obstacle-avoidance-sensor_Fn.pdf'


import LidarSensor from '../assets/Lidar Sensor.pdf'

import SAFETY_DOOR_LOCK_AR1 from '../assets/SAFETY-DOOR-LOCK_AR1.pdf'
import SAFETY_DOOR_LOCK_AR2 from '../assets/SAFETY-DOOR-LOCK_AR2.pdf'
import SAFETY_DOOR_LOCK_AR3 from '../assets/SAFETY-DOOR-LOCK_AR3.pdf'



import StandardTypeBMLSeriesPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/Standard Type(BML Series).pdf'
import BZLSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BZL Series Catalog.pdf'
import BCLSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BCL Series Catalog.pdf'
import BPLSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BPL Series Catalog.pdf'
import BALSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BAL Series Catalog.pdf'
import BKLSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BKL Series Catalog.pdf'
import BSLSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/BSL Series Catalog.pdf'
import SAFSeriesCatalogPdf from '../assets/AREA SECURITY OBSTACLE AVOIDANCE SENSOR/SAF Series Catalog.pdf'


export default function AreaObstacleAvoidanceSensor() {
  const [activeTab, setActiveTab] = useState('Lidar Scanner');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="AreaObstacleAvoidanceSensor-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner27">
        <div className="hero-banner27-content">
          <h1>AREA/SECURITY/OBSTACLE AVOIDANCE SENSOR</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Area/Security/Obstacle Avoidance Sensor</span>
          </div>
        </div>
      </div>

      {/* areaintro Section */}
      <section className="sensor-areaintro">
        <div className="areaintro-left">
          <img src={sensorMain} alt="Obstacle Avoidance Sensor" />
        </div>
        <div className="areaintro-right">
          <h2>Area/Security/Obstacle Avoidance Sensor</h2>
          <ul>
            <li>Adopting line synchronization mode with safe and reliable performance.</li>
            <li>Detecting fingers, hands and arms in different sizes.</li>
            <li>A wide range of dimensions, protection heights and detection methods are available.</li>
            <li>TOF detection principle, obstacle avoidance type and navigation type optional</li>
            <li>Scanning range up to 360°, maximum scanning frequency up to 30Hz</li>
            <li>Serial port (Type-C interface) communication, online output of measurement data (including distance in each direction and light intensity)</li>
          </ul>
          <div className="areaintro-buttons">
            <a href={area_obstacle_avoidance_sensor_Fn}  target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
            <button className="download-catalog-btn"><FaFilePdf /> Full Catalog Download</button>
            </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </section>

      {/* Tabs */}
      <div className="sensor-tabs">
        <div className="tab-buttons">
          {[ 'Lidar Scanner', 'Safety Light Curtain', 'Safety Door Lock'/*,'Technical Specifications'*/].map(tab => (
            <button
              key={tab}
              className={activeTab === tab ? 'active' : ''}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="tab-content">
          {activeTab === 'Technical Specifications' && (
            <table className="spec-table">
              <tbody>
                <tr><td>Model no:</td><td>AR3 Series</td></tr>
                <tr><td>Degree of protection</td><td>IP67</td></tr>
                <tr><td>Type</td><td>AC-15 / DC-13</td></tr>
                <tr><td>Operating speed</td><td>0.1M~0.5m/s</td></tr>
                <tr><td>Ambient temp</td><td>-10℃ ~ +50℃ without freezing</td></tr>
              </tbody>
            </table>
          )}

          {/* {activeTab === 'Lidar Scanner' && (
            <div className="tab-items">
              <div className="item-card">
                <img src={lidar1} alt="Lidar 1" />
                <h4>TOF LIDAR Scanner (AS-21C/41C)</h4>
                <ul>
                  <li>20M/40M sensing distance</li>
                  <li>300° scanning range</li>
                  <li>25Hz scanning frequency</li>
                  <li>0.125° resolution</li>
                </ul>
              </div>
              <div className="item-card">
                <img src={lidar2} alt="Lidar 2" />
                <h4>MINI LIDAR Scanner (AS-11C)</h4>
                <ul>
                  <li>360° scanning range</li>
                  <li>12.5Hz scanning frequency</li>
                  <li>0.5° resolution</li>
                </ul>
              </div>
              <div className="item-card">
                <img src={lidar3} alt="Lidar 3" />
                <h4>MINI LIDAR Scanner (AS-100C)</h4>
                <ul>
                  <li>Height: 72mm, 360° scanning</li>
                  <li>0.05° angle resolution</li>
                  <li>Range: 0.2m–100m</li>
                </ul>

              </div>
              <div className="item-card"></div>
              <br/>
                <a href={area_obstacle_avoidance_sensor_Fn}  target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
                            
            </div>
            
          )} */}

{activeTab === 'Lidar Scanner' && (
  <div className="lidarSpecs-wrapper">
    <div className="specs-image-wrapper">
      <img
        src={LidarSensorIMG} // or another image like lidarSpecsImg
        alt="Lidar Scanner Specs"
        className="lidarSpecs-img"
      />
      <div className="lidarSpecs-download-btn">
        <a href={LidarSensor} target="_blank" rel="noopener noreferrer">
          <button>
            <FaFilePdf style={{ marginRight: '8px' }} /> Download
          </button>
        </a>
        <br/>
        <br/>
      </div>
    </div>
  </div>
)}

          {activeTab === 'Safety Light Curtain' && (
            <div className="tab-items">
              <div className="item-card">
                <img src={curtain1} alt="Curtain 1" />
                <h4>Standard Type(BML Series)</h4>
                <ul>
                  <li>Cross—sectional size is 30mm * 30mm.</li>
                  <li>Multiple resolutions for option.</li>
                  <li>3M cable as standard</li>
                </ul>
                <a href={StandardTypeBMLSeriesPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain2} alt="Curtain 2" />
                <h4>Top-emitting Type(BZL Series)</h4>
                <ul>
                  <li>Frontal detection, thickness is only 17mm.</li>
                  <li>With plastic installation hole, easy to install.</li>
                  <li>The protection distance can be customized according to clients’ requirements.</li>
                </ul>
                <a href={BZLSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain3} alt="Curtain 3" />
                <h4>Side-emitting Type(BCL Series)</h4>
                <ul>
                  <li>Side detection, thickness is only 15mm.</li>
                  <li>With plastic installation hole, easy to install.</li>
                  <li>Small upper and lower blind area, saving installation space.</li>
                </ul>
                <a href={BCLSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain4} alt="Curtain 4" />
                <h4>Waterproof Type(BPL Series)</h4>
                <ul>
                  <li>Cylindrical design with a diameter of only 48mm</li>
                  <li>High-strength sealing ring, IP68</li>
                  <li>Extraordinary self-checking function and strong anti-interference capability</li>
                </ul>
                <a href={BPLSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain5} alt="Curtain 5" />
                <h4>Measuring Type (BAL Series)</h4>
                <ul>
                  <li>Surface mount technology for superior shock resistance</li>
                  <li>Extraordinary self-checking function and strong anti-interference capability</li>
                </ul>
                <a href={BALSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain6} alt="Curtain 6" />
                <h4>Economical Type (BKL Series)</h4>
                <ul>
                  <li>Strong anti-electromagnetic interference</li>
                  <li>Class 4 safety grating design standards</li>
                  <li>Satisfying different installation scenarios suitable for a variety of working environments</li>
                </ul>
                <a href={BKLSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain7} alt="Curtain 7" />
                <h4>GuidanceEconomical type(BSL Series)</h4>
                <ul>
                  <li>Response time ≥ 20ms, fast response for safe production</li>
                  <li>Detection distance of 1-6m, covering general protection scenarios.</li>
                  <li>Robust housing construction, resistant to pressure, vibration and shock.</li>
                </ul>
                <a href={BSLSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain8} alt="Curtain 8" />
                <h4>Safety Light Curtain(saAF series)</h4>
                <ul>
                  <li>Type 4 standard providing security providing security for high-risk sites</li>
                  <li>Beam Pitch: 10mm, 20mm, 30mm and 40mm. Protection distance: 3m or 12m, 8~20m</li>
                </ul>
                <a href={SAFSeriesCatalogPdf} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={curtain9} alt="Curtain 9" />
                <h4>Safety Switches(RFID)</h4>
                <ul>
                  <li>Coding type : Coded target</li>
                  <li>Horizontal working distance : 0~10mm</li>
                  <li>Vertical working distance : 0~8mm</li>
                </ul>
                <a href={area_obstacle_avoidance_sensor_Fn} target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
<br/>
                  <div className="curtain-download-wrapper">
    
      <br/>
      <br/>
    
  </div>
            </div>
          )}
{activeTab === 'Safety Door Lock' && (
            <div className="tab-items">
              <div className="item-card">
                <img src={lock1} alt="Lock 1" />
                <h4>Standard Type(BML Series)</h4>
                <ul>
                  <li>Cross—sectional size is 30mm * 30mm.</li>
                  <li>Multiple resolutions for option.</li>
                  <li>3M cable as standard</li>
                </ul>
<br/>
                <a href={SAFETY_DOOR_LOCK_AR1}  target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>

              </div>
              <div className="item-card">
                <img src={lock2} alt="Lock 2" />
                <h4>Top-emitting Type(BZL Series)</h4>
                <ul>
                  <li>Frontal detection, thickness is only 17mm.</li>
                  <li>With plastic installation hole, easy to install.</li>
                  <li>The protection distance can be customized according to clients’ requirements.</li>
                </ul>
                <a href={SAFETY_DOOR_LOCK_AR2}  target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              <div className="item-card">
                <img src={lock3} alt="Lock 3" />
                <h4>Side-emitting Type(BCL Series)</h4>
                <ul>
                  <li>Side detection, thickness is only 15mm.</li>
                  <li>With plastic installation hole, easy to install.</li>
                  <li>Small upper and lower blind area, saving installation space.</li>
                </ul>
<br/>
                <a href={SAFETY_DOOR_LOCK_AR3}  target="_blank" rel="noopener noreferrer">
                  <button className="sensor-download-btn"><FaFilePdf />Download</button>
                </a>
              </div>
              

            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
